<div class="row" *ngIf="minConfig != null && maxConfig != null">
  <div [ngClass]="columnSize">
      <app-edtell-datetime-picker [config]="minConfig"></app-edtell-datetime-picker>
  </div>
  <div [ngClass]="columnSize">
      <app-edtell-datetime-picker [config]="maxConfig"></app-edtell-datetime-picker>
  </div>
</div>
